export default {
  postPreferredLocation: 'postPreferredLocation',
  getPreferredLocations: 'getPreferredLocations',
  deletePreferredLocation: 'deletePreferredLocation',
};
